import React from "react";
import "../../Styles/Loading.css";

export default function Loading() {
  return (
    <div className="loading--main--container">
      <div className="loading--container">
        <p className="loading--letter">l</p>
        <p className="loading--letter">o</p>
        <p className="loading--letter">a</p>
        <p className="loading--letter">d</p>
        <p className="loading--letter">i</p>
        <p className="loading--letter">n</p>
        <p className="loading--letter">g</p>
        <p className="loading--letter">.</p>
        <p className="loading--letter">.</p>
        <p className="loading--letter">.</p>
      </div>
    </div>
  );
}
